import { Link, useNavigate } from "@remix-run/react";
import { FaChessKnight } from "react-icons/fa6";
import { PrimaryButton } from "../PrimaryButton";
import { ContainerTextFlip } from "../animated/ContainerTextFlip";
import { motion } from "framer-motion";
import posthog from "posthog-js";

export const Hero = () => {
  const navigate = useNavigate();
  return (
    <div className="h-dvh flex flex-col justify-between items-center px-4 w-full py-5">
      <div className="flex flex-row w-full justify-between items-center text-2xl font-bangers">
        <Link to={"/"}>
          <FaChessKnight className="" />
        </Link>
        <Link to={"/sign-in"} className="opacity-80">
          Log In
        </Link>
      </div>

      <motion.div
        layout
        className="flex flex-col justify-center items-center gap-2"
      >
        <ContainerTextFlip
          words={["Confidence", "Humor", "Flirt"]}
          textClassName="font-bangers"
          animationDuration={700}
          interval={1600}
        />
        <motion.h1 className="font-bangers text-4xl text-center inline-block">
          that feels natural
        </motion.h1>
        <h2 className="text-sm font-normal text-center opacity-80">
          ManUp uses science-backed training and real-world simulations to help
          you stay confident, humorous and authentic when you’re with her
        </h2>
      </motion.div>

      <div className="mb-10">
        <PrimaryButton
          onClick={() => {
            posthog.capture("new_user_started_onboarding_from_home_page");
            navigate("/onboard");
          }}
        >
          Start Now
        </PrimaryButton>
      </div>
    </div>
  );
};
